import $ from "jquery";

$(document).ready(function() {

    $('[data-select]').on('click', function() {
        var $attr = $(this).attr('data-select'),
            $target = $(this).parents('.team-item__content-wrap').find('[data-tab=' + $attr + ']')


        $(this).addClass('active').siblings('li').removeClass('active')

        $target.addClass('open').siblings('[data-tab]').removeClass('open')


        var $targetHeight = $target.outerHeight()

        $target.parents('.team-item__content-tabs').css({
            'height': $targetHeight + 'px',
        });
    });


    $('[data-team_toggler]').on('click', function() {
        var $wrap = $(this).siblings('.team-item__content-wrap')
        if ($wrap.hasClass('open')) {
            $wrap.slideUp(200).removeClass('open')

        } else {
            $wrap.slideDown(200).addClass('open')
            setTimeout(function(){
            	$wrap.find('[data-select]').first().click()
						},200);

        }

    });


});